import { HevoCustomer } from '../../core/interfaces/customers';

export const CLIENTS: HevoCustomer[] = [
  {
    name: 'DoorDash',
    logoWhite: 'https://res.cloudinary.com/hevo/image/upload/f_auto,q_auto,w_200/v1/hevo-website/customer/logo-white/84e34f51a3a5484f9621abbab4198eb0_dbytkr'
  },
  {
    name: 'ThoughtSpot',
    logoWhite: 'https://res.cloudinary.com/hevo/image/upload/f_auto,q_auto,w_200/v1/hevo-website/customer/logo-white/a36686db42474a1893900e4fbf81cc52_skhh19'
  },
  {
    name: 'Postman',
    logoWhite: 'https://res.cloudinary.com/hevo/image/upload/f_auto,q_auto,w_200/v1/hevo-website/customer/logo-white/b32cb4bf7f284ec39ebce8b443a0b54e_rcv7ne'
  },
  {
    name: 'Shopify',
    logoWhite: 'https://res.cloudinary.com/hevo/image/upload/f_auto,q_auto,w_200/v1/hevo-website/customer/logo-white/b4e6868b9bdd4883832a2647a1d58674_cezq2i'
  },
  {
    name: 'flexport',
    logoWhite: 'https://res.cloudinary.com/hevo/image/upload/f_auto,q_auto,w_200/v1/hevo-website/customer/logo-white/970798ede48c4973b7c908d4cc1e9a7b_rwup0c'
  },
  {
    name: 'Trinet Zenefits',
    logoWhite: 'https://res.cloudinary.com/hevo/image/upload/f_auto,q_auto,w_200/v1/hevo-website/customer/logo-white/cea257dcfe5540e795b3f124bc80c746_pslmqy'
  }
];
